import { Component } from 'preact'
import $ from 'jquery'
import FeaturedSidebar from './featuredSidebar'
import FeaturedBanner from './featuredBanner'

const showWidget = (widget, data) => {
  const widgetComponents = {
    featuredSide: <FeaturedSidebar data={data} />,
    featuredBanner: <FeaturedBanner data={data} />
  }

  return widgetComponents[widget]
}

class FeaturedTopicsWrapper extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: []
    }
  }
  componentDidMount () {
    $.get(`/widget/${this.props.widget}`, function (data) {
      this.setState({ data: data })
    }.bind(this))
  }
  render (props, state) {
    if (!state.data.length) return
    return (
      <div className={props.widget}>
        {showWidget(props.widget, state.data)}
      </div>
    )
  }
}

export default FeaturedTopicsWrapper
